module.exports = __webpack_public_path__ + "static/media/genericError.b4d08b25.svg";